import * as React from "react";

import ComponentPage from "../../Components/ComponentPage";
import Anatomy from "../../Docs/Components/Tabs/TabsAnatomy.mdx";
import Usage from "../../Docs/Components/Tabs/TabsUsage.mdx";
import DevGuidance from "../../Docs/Components/Tabs/TabsDevGuidance.mdx";

import Examples from "../../Docs/Components/Tabs/TabsExamples";
        
class Page extends React.Component {
public render() {
    return (
        <ComponentPage
            name="Tabs"
            description="Tabs divide and organize related content, and can be used to navigate between two or more related views within the same parent container."
            apiSources={["azure-devops-ui/Components/Tabs/Tabs.Props.d.ts"]}
            examples={Examples}
            internalLinks={{"figma":"https://www.figma.com/file/PCqdPCcjzhgPwUQdyXHhifLF/Exploration-Pivot-bar?node-id=0%3A1"}}
            status={{"design":"done","code":"done","docs":"done"}}
            anatomy={Anatomy}
            usage={Usage}
            devGuidance={DevGuidance}
        />
    );
}
}
        
export default Page;